
import { TableItemContainer, TableItemTextView, TableItemView } from "components/shared";
import { UIAmountInput } from "components/ui";
import React from "react";
import { SVGAsset } from "res";

/**
 * @function ACHTransfersFromTableRow
 * @param {STRING} nickname - Sets the ACH account nickname text. 
 * @param {STRING} accountNumber - Sets the ACH account number text. 
 * @param {STRING} accountType - Sets the ACH account type text.
 * @param {STRING} amount - Sets the ACH dollar amount for text input.
 * @return {React.Component}
 * @exported true
 * @description - This is the table row used for the One Time ACH From table view.
 */
export default function ACHTransfersFromTableRow(props) {
    const achFromAccount = props.achFromAccount ?? {};
    const account = achFromAccount.account ?? {};
    const onACHFromAccountChange = props.onACHFromAccountChange ?? (() => {});
    const onACHFromAccountDelete = props.onACHFromAccountDelete ?? (() => {});
    const nickname = props.nickname ?? "[nickname]";
    const accountNumber = props.accountNumber ?? "[accountNumber]";
    const accountType = props.accountType ?? "[accountType]";
    const amount = props.amount ?? "[amount]";
    const nicknameDataPoint = props.dataPoint ? { "dataPoint" : `${ props.dataPoint }_nickname` } : {};
    const accountNumberDataPoint = props.dataPoint ? { "dataPoint" : `${ props.dataPoint }_account_number` } : {};
    const accountTypeDataPoint = props.dataPoint ? { "dataPoint" : `${ props.dataPoint }_account_type` } : {};
    const accountAmountDataPoint = props.dataPoint ? { "dataPoint" : `${ props.dataPoint }_account_amount` } : {};
    const accountDeleteIconDataPoint = props.dataPoint ? { "data-point" : `${ props.dataPoint }_account_delete_icon` } : {};

    return (
        <TableItemContainer>
            <TableItemTextView className="nickname-col" text={ account.nickname } { ...nicknameDataPoint } />
            <TableItemTextView className="account-number-col" text={ account.number } { ...accountNumberDataPoint } />
            <TableItemTextView className="account-type-col" text={ account.type } { ...accountTypeDataPoint } />
            <TableItemView>
                <UIAmountInput value={ achFromAccount.amount.amount } { ...accountAmountDataPoint } onChange={ onACHFromAccountChange(achFromAccount) } />
            </TableItemView>
            <TableItemView className="trash-can-col text-right">
                <a onClick={ onACHFromAccountDelete(achFromAccount) }>
                    <SVGAsset id="TrashcanXIcon" { ...accountDeleteIconDataPoint } className="trash-can-x-icon" />
                </a>
            </TableItemView>
        </TableItemContainer>
    )
}
